module.exports = __webpack_public_path__ + "img/horizontal_4_4_8019.ff6441e8.png";